import { useState, useEffect } from "react";
import styles from "../RightSidebar/rightsidebar.module.css";
import { useGlobalContext } from "../../Context/GlobalContext";

const Notes = ({ fromEdit = false }) => {
	const {
		editableBooking, 
		setItemData, 
		setEditedItemData, 
		setNewAppointmentSlots
	} = useGlobalContext();
	const [notes, setNotes] = useState("");
	const [hasNotes, setHasNotes] = useState(false);
	// ✅ On first load (for edit), pre-fill note if it exists
	useEffect(() => {
		if (fromEdit && editableBooking?.note) {
			setNotes(editableBooking.note);
			setHasNotes(editableBooking.note ? true : false);
		}
	}, [fromEdit, editableBooking]);

	// ✅ Sync notes into global itemData on change
	useEffect(() => {
		setItemData((prev) => ({
			...prev,
			note: notes || "",
		}));
		if (fromEdit) {
			setEditedItemData((prev) => ({
				...prev,
				note: notes || "",
			}));
		}

		if (notes !== "") {
			setNewAppointmentSlots((prev) => [
				...prev,
				{
					notes: notes ? true : false,
					hasNotes: hasNotes ? true : false,
					isPlaceholder: true,
				},
			]);
		}
		
	}, [notes, setItemData]);

	return (
		<div>
			<textarea
				value={notes}
				onChange={(e) => setNotes(e.target.value)}
				className={`${styles.notesInput} formControl`}
				placeholder="Notes (optional)"
			/>
		</div>
	);
};

export default Notes;
